module.exports = __webpack_public_path__ + "img/DSC_9937-2.166c0e4a.jpeg";